/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClientDocument } from '../models/client-document';
import { ClientDocumentType } from '../models/client-document-type';
import { Document } from '../models/document';
import { FileUrl } from '../models/file-url';


/**
 * Documents API
 */
@Injectable({
  providedIn: 'root',
})
export class DocumentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDocument
   */
  static readonly GetDocumentPath = '/documents/{id}';

  /**
   * Get metadata for one document.
   *
   * Get metadata for one document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocument$Response(params: {
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Document>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetDocumentPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Document>;
      })
    );
  }

  /**
   * Get metadata for one document.
   *
   * Get metadata for one document
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDocument(params: {
    id: number;
    context?: HttpContext
  }
): Observable<Document> {

    return this.getDocument$Response(params).pipe(
      map((r: StrictHttpResponse<Document>) => r.body as Document)
    );
  }

  /**
   * Path part for operation deleteClientBankAccount
   */
  static readonly DeleteClientBankAccountPath = '/clients/{client_id}/bank-accounts/{id}';

  /**
   * Delete the bank account.
   *
   * Delete the bank account
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClientBankAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientBankAccount$Response(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DeleteClientBankAccountPath, 'delete');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete the bank account.
   *
   * Delete the bank account
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteClientBankAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientBankAccount(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.deleteClientBankAccount$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getClientDocuments
   */
  static readonly GetClientDocumentsPath = '/clients/{client_id}/documents';

  /**
   * Get documents for a client.
   *
   * Get documents for a client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocuments$Response(params: {
    client_id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ClientDocument>>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetClientDocumentsPath, 'get');
    if (params) {
      rb.path('client_id', params.client_id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ClientDocument>>;
      })
    );
  }

  /**
   * Get documents for a client.
   *
   * Get documents for a client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocuments(params: {
    client_id: number;
    context?: HttpContext
  }
): Observable<Array<ClientDocument>> {

    return this.getClientDocuments$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ClientDocument>>) => r.body as Array<ClientDocument>)
    );
  }

  /**
   * Path part for operation createClientDocument
   */
  static readonly CreateClientDocumentPath = '/clients/{client_id}/documents';

  /**
   * Create a document for a client.
   *
   * Create a document for a client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClientDocument()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createClientDocument$Response(params: {
    client_id: number;
    context?: HttpContext
    body: {
'file'?: Blob;
}
  }
): Observable<StrictHttpResponse<ClientDocument>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.CreateClientDocumentPath, 'post');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDocument>;
      })
    );
  }

  /**
   * Create a document for a client.
   *
   * Create a document for a client
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createClientDocument$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createClientDocument(params: {
    client_id: number;
    context?: HttpContext
    body: {
'file'?: Blob;
}
  }
): Observable<ClientDocument> {

    return this.createClientDocument$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDocument>) => r.body as ClientDocument)
    );
  }

  /**
   * Path part for operation getClientDocument
   */
  static readonly GetClientDocumentPath = '/clients/{client_id}/documents/{id}';

  /**
   * Get metadata for one document.
   *
   * Get metadata for one document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocument$Response(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<ClientDocument>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetClientDocumentPath, 'get');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDocument>;
      })
    );
  }

  /**
   * Get metadata for one document.
   *
   * Get metadata for one document
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocument(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<ClientDocument> {

    return this.getClientDocument$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDocument>) => r.body as ClientDocument)
    );
  }

  /**
   * Path part for operation updateClientDocument
   */
  static readonly UpdateClientDocumentPath = '/clients/{client_id}/documents/{id}';

  /**
   * Update metadata for one document.
   *
   * Update metadata for one document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateClientDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateClientDocument$Response(params: {
    client_id: number;
    id: number;
    context?: HttpContext
    body: ClientDocument
  }
): Observable<StrictHttpResponse<ClientDocument>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.UpdateClientDocumentPath, 'put');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDocument>;
      })
    );
  }

  /**
   * Update metadata for one document.
   *
   * Update metadata for one document
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateClientDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateClientDocument(params: {
    client_id: number;
    id: number;
    context?: HttpContext
    body: ClientDocument
  }
): Observable<ClientDocument> {

    return this.updateClientDocument$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDocument>) => r.body as ClientDocument)
    );
  }

  /**
   * Path part for operation deleteClientDocument
   */
  static readonly DeleteClientDocumentPath = '/clients/{client_id}/documents/{id}';

  /**
   * Delete the document.
   *
   * Delete the document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClientDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientDocument$Response(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.DeleteClientDocumentPath, 'delete');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete the document.
   *
   * Delete the document
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteClientDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClientDocument(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<void> {

    return this.deleteClientDocument$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getClientDocumentUrl
   */
  static readonly GetClientDocumentUrlPath = '/clients/{client_id}/documents/{id}/file';

  /**
   * Get a link to the contents of the document.
   *
   * Get a link to the contents of the document
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientDocumentUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocumentUrl$Response(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<FileUrl>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetClientDocumentUrlPath, 'get');
    if (params) {
      rb.path('client_id', params.client_id, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FileUrl>;
      })
    );
  }

  /**
   * Get a link to the contents of the document.
   *
   * Get a link to the contents of the document
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientDocumentUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocumentUrl(params: {
    client_id: number;
    id: number;
    context?: HttpContext
  }
): Observable<FileUrl> {

    return this.getClientDocumentUrl$Response(params).pipe(
      map((r: StrictHttpResponse<FileUrl>) => r.body as FileUrl)
    );
  }

  /**
   * Path part for operation getClientDocumentTypes
   */
  static readonly GetClientDocumentTypesPath = '/client-document-types';

  /**
   * Get list of client document types.
   *
   * Get list of client document types
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClientDocumentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocumentTypes$Response(params?: {
    context?: HttpContext
  }
): Observable<StrictHttpResponse<Array<ClientDocumentType>>> {

    const rb = new RequestBuilder(this.rootUrl, DocumentsService.GetClientDocumentTypesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ClientDocumentType>>;
      })
    );
  }

  /**
   * Get list of client document types.
   *
   * Get list of client document types
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClientDocumentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClientDocumentTypes(params?: {
    context?: HttpContext
  }
): Observable<Array<ClientDocumentType>> {

    return this.getClientDocumentTypes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ClientDocumentType>>) => r.body as Array<ClientDocumentType>)
    );
  }

}
